import { Button, List, Modal } from "../../../components";
import { OrderSummary } from "../../../layouts";
import { Order } from "../../../types/item";
import { Props } from "../viewModel";
import { useRef } from "react";
import Item from "./item";

const View = ({ orders, loading, trackOrder, reorder }: Props) => {
  const orderModalRef = useRef<any>();

  const renderItem = (order: Order) => {
    return (
      <Item
        order={order}
        onReorder={() => {
          reorder(order);
        }}
        onTrackOrder={async () => trackOrder(order)}
        onViewInfo={() => orderModalRef.current.open(order)}
      />
    );
  };

  return (
    <>
      {loading ? (
        <List
          bordered
          dataSource={Array.from({ length: 3 }).map((_, index) => ({
            id: index,
          }))}
          renderItem={({ id }) => (
            <List.ItemSkeleton uniqueKey={`order-${id}`} />
          )}
        />
      ) : (
        <List
          hoverable
          bordered
          dataSource={orders}
          renderItem={renderItem}
          empty={{
            description:
              "Hungry? Your orders will appear here once you place one!",
          }}
        />
      )}
      <Modal
        classNames={{ body: "p-0" }}
        ref={orderModalRef}
        title={(order) =>
          order?.orderNo != null && order.orderNo !== ""
            ? `Order #${order.orderNo}`
            : "Order"
        }
        child={(order: Order) => (
          <div className="flex min-h-0 flex-1 flex-col">
            <div className="min-h-0 flex-1 overflow-y-auto">
              <OrderSummary {...order} />
            </div>
            <div className="px-[2.4rem] pb-[2.4rem]">
              <Button
                title="Reorder"
                className="m-30-t w-100 shrink-0"
                onClick={async () => {
                  const added = await reorder(order);
                  if (added) orderModalRef.current.close();
                }}
              />
            </div>
          </div>
        )}
      />
    </>
  );
};

export default View;
